// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"014ad0d1","37":"67b08660","512":"6013e47d","988":"35a2aa58"}[chunkId] + ".chunk.js";
};